import { createContext } from 'react';

//@ts-expect-error server init
// eslint-disable-next-line react-refresh/only-export-components
export const HeaderCookieContext = createContext<string>();

export function HeaderCookieProvider({
  value,
  children,
}: {
  value: string;
  children: React.ReactNode;
}) {
  return <HeaderCookieContext.Provider value={value}>{children}</HeaderCookieContext.Provider>;
}
